import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=2106ea23"
import script from "./Achievement.vue?vue&type=script&lang=ts"
export * from "./Achievement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports